export const showTrafficSelector = ({showTraffic}) => showTraffic